// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//   Phone,
//   Facebook,
//   Twitter,
//   Instagram,
//   Youtube,
//   ChevronDown,
//   Menu,
//   X,
// } from "lucide-react";

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [showServices, setShowServices] = useState(false);

//   const servicesLinks = [
//     "Building Renovation",
//     "Civil Contract",
//     "Architecture",
//     "Interior Design",
//     "Tiles Installation",
//     "Plumbing",
//   ];

//   useEffect(() => {
//     if (!menuOpen) setShowServices(false);
//   }, [menuOpen]);

//   return (
//     <header className="sticky top-0 z-50 ">
//       {/* Top Bar */}
//       <div className="bg-[#7a0000] text-white flex justify-between items-center px-4 md:px-16 py-2 text-sm">
//         <div>Property Management Services</div>
//         <div className="flex items-center gap-4">
//           <span className="flex items-center gap-1">
//             <Phone size={14} className="text-yellow-400" />
//             <span>+91&nbsp;97867&nbsp;11000, 99620&nbsp;14805</span>
//           </span>
//           <div className="hidden sm:flex gap-2">
//             <Facebook size={16} />
//             <Twitter size={16} />
//             <Instagram size={16} />
//             <Youtube size={16} />
//           </div>
//         </div>
//       </div>

//       {/* Bottom Navigation */}
//       <div className="bg-white shadow-md">
//         <div className="flex justify-between items-center px-4 md:px-16 py-4">
//           <Link to="/">
//             <h1 className="text-xl font-bold bg-gradient-to-r from-red-900 to-yellow-500 bg-clip-text text-transparent animate-pulse">
//               Sanctus property pvt ltd
//             </h1>
//           </Link>

//           {/* Desktop links */}

//           <nav className="hidden md:flex justify-center items-center gap-10 flex-1 text-gray-700 font-medium">
//             {[
//               "Home",
//               "About",
//               "Services",
//               "Projects",
//               "Real Estate",
//               "Contact",
//             ].map((item) =>
//               item === "Services" ? (
//                 <div key="Services" className="relative group cursor-pointer">
//                   <div className="flex items-center gap-1 transition-all duration-300 hover:text-red-600 relative after:block after:h-[2px] after:bg-red-600 after:scale-x-0 group-hover:after:scale-x-100 after:transition-transform after:origin-left">
//                     <span>Services</span>
//                     <ChevronDown size={14} />
//                   </div>
//                   <div className="absolute top-full left-0 hidden group-hover:block bg-white shadow-lg rounded-md py-2 w-56 z-50">
//                     {servicesLinks.map((service) => (
//                       <Link
//                         key={service}
//                         to={`/services/${service
//                           .toLowerCase()
//                           .replace(/\s+/g, "-")}`}
//                         className="block px-4 py-2 text-sm relative after:block after:h-[2px] after:bg-red-600 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-red-600 hover:pl-2"
//                       >
//                         {service}
//                       </Link>
//                     ))}
//                   </div>
//                 </div>
//               ) : (
//                 <Link
//                   key={item}
//                   to={
//                     item === "Home"
//                       ? "/"
//                       : `/${item.toLowerCase().replace(/\s+/g, "-")}`
//                   }
//                   className="relative after:block after:h-[2px] after:bg-red-600 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-red-600 hover:scale-105"
//                 >
//                   {item}
//                 </Link>
//               )
//             )}
//           </nav>

//           {/* Mobile hamburger */}
//           <button
//             className="md:hidden transition-transform duration-300 hover:scale-110"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? <X /> : <Menu />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Off‑Canvas Drawer */}
//       <div
//         className={`md:hidden fixed top-0 left-0 w-64 h-screen bg-white shadow-lg z-50 transform transition-transform duration-300 ${
//           menuOpen ? "translate-x-0" : "-translate-x-full"
//         }`}
//       >
//         {/* Drawer header */}
//         <div className="flex justify-between items-center px-4 py-4 border-b">
//           <h2 className="text-lg font-bold text-red-700">Menu</h2>
//           <button onClick={() => setMenuOpen(false)}>
//             <X size={24} />
//           </button>
//         </div>

//         {/* Drawer links */}
//         <div className="px-4 py-2 flex flex-col gap-4 text-gray-700 font-medium">
//           {[
//             "Home",
//             "About",
//             "Services",
//             "Projects",
//             "Real Estate",
//             "Contact",
//           ].map((item) => {
//             if (item === "Services") {
//               return (
//                 <div key="Services">
//                   <button
//                     className="flex items-center justify-between w-full"
//                     onClick={() => setShowServices(!showServices)}
//                   >
//                     <span>Services</span>
//                     <ChevronDown
//                       size={16}
//                       className={`transition-transform ${
//                         showServices ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   {/* Services box */}
//                   {showServices && (
//                     <div className="mt-2 border border-gray-300 rounded-md p-3 bg-gray-50 shadow-inner">
//                       {/* <h4 className="text-sm font-semibold mb-2 text-red-700">
//                         Our Services
//                       </h4> */}

//                       {/* NEW: divide-y adds separator lines */}
//                       <div className="flex flex-col divide-y divide-gray-300">
//                         {servicesLinks.map((service) => (
//                           <Link
//                             key={service}
//                             to={`/services/${service
//                               .toLowerCase()
//                               .replace(/\s+/g, "-")}`}
//                             onClick={() => {
//                               setMenuOpen(false);
//                               setShowServices(false);
//                             }}
//                             className="py-2 pl-2 text-sm relative after:block after:h-[2px] after:bg-red-600 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-red-600 hover:pl-3"
//                           >
//                             {service}
//                           </Link>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               );
//             }

//             /* All other top‑level links */
//             const path =
//               item === "Home"
//                 ? "/"
//                 : `/${item.toLowerCase().replace(/\s+/g, "-")}`;
//             return (
//               <Link
//                 key={item}
//                 to={path}
//                 onClick={() => setMenuOpen(false)}
//                 className="relative after:block after:h-[2px] after:bg-red-600 after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-red-600 hover:pl-2"
//               >
//                 {item}
//               </Link>
//             );
//           })}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import {
//   Phone,
//   Facebook,
//   Twitter,
//   Instagram,
//   Youtube,
//   ChevronDown,
//   Menu,
//   X,
// } from "lucide-react";

// const Header = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const [showServices, setShowServices] = useState(false);

//   const servicesLinks = [
//     "Building Renovation",
//     "Civil Contract",
//     "Architecture",
//     "Interior Design",
//     "Tiles Installation",
//     "Plumbing",
//   ];

//   useEffect(() => {
//     if (!menuOpen) setShowServices(false);
//   }, [menuOpen]);

//   return (
//     <header className="sticky top-0 z-50 ">
//       {/* Top Bar - Changed background color to a darker green based on #6FEF34 */}
//       <div className="bg-[#419E3A] text-white flex justify-between items-center px-4 md:px-16 py-2 text-sm">
//         <div>Property Management Services</div>
//         <div className="flex items-center gap-4">
//           <span className="flex items-center gap-1">
//             {/* Kept yellow for icon as it provides a good contrast */}
//             <Phone size={14} className="text-yellow-400" />
//             <span>+91&nbsp;97867&nbsp;11000, 99620&nbsp;14805</span>
//           </span>
//           <div className="hidden sm:flex gap-2">
//             <Facebook size={16} />
//             <Twitter size={16} />
//             <Instagram size={16} />
//             <Youtube size={16} />
//           </div>
//         </div>
//       </div>

//       {/* Bottom Navigation */}
//       <div className="bg-blue-700 shadow-md">
//         <div className="flex justify-between items-center px-4 md:px-16 py-4">
//           <Link to="/">
//             {/* Changed gradient start color to a darker green based on #6FEF34 */}
//             <h1 className="text-xl font-bold bg-gradient-to-r from-[#6FEF34] to-yellow-500 bg-clip-text text-transparent animate-pulse">
//               Sanctus property pvt ltd
//             </h1>
//           </Link>

//           {/* Desktop links */}
//           <nav className="hidden md:flex justify-center items-center gap-10 flex-1 text-white font-medium">
//             {[
//               "Home",
//               "About",
//               "Services",
//               "Projects",
//               "Real Estate",
//               "Contact",
//             ].map((item) =>
//               item === "Services" ? (
//                 <div key="Services" className="relative group cursor-pointer">
//                   {/* Changed hover text and underline color to #6FEF34 */}
//                   <div className="flex items-center gap-1 transition-all duration-300 hover:text-[#6FEF34] relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 group-hover:after:scale-x-100 after:transition-transform after:origin-left">
//                     <span>Services</span>
//                     <ChevronDown size={14} />
//                   </div>
//                   <div className="absolute top-full left-0 hidden group-hover:block bg-white shadow-lg rounded-md py-2 w-56 z-50">
//                     {servicesLinks.map((service) => (
//                       <Link
//                         key={service}
//                         to={`/services/${service
//                           .toLowerCase()
//                           .replace(/\s+/g, "-")}`}
//                         // Changed hover text and underline color to #6FEF34
//                         className="block px-4 py-2 text-sm relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-[#6FEF34] hover:pl-2"
//                       >
//                         {service}
//                       </Link>
//                     ))}
//                   </div>
//                 </div>
//               ) : (
//                 <Link
//                   key={item}
//                   to={
//                     item === "Home"
//                       ? "/"
//                       : `/${item.toLowerCase().replace(/\s+/g, "-")}`
//                   }
//                   // Changed hover text and underline color to #6FEF34
//                   className="relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-[#6FEF34] hover:scale-105"
//                 >
//                   {item}
//                 </Link>
//               )
//             )}
//           </nav>

//           {/* Mobile hamburger */}
//           <button
//             className="md:hidden transition-transform duration-300 hover:scale-110"
//             onClick={() => setMenuOpen(!menuOpen)}
//           >
//             {menuOpen ? <X /> : <Menu />}
//           </button>
//         </div>
//       </div>

//       {/* Mobile Off‑Canvas Drawer */}
//       <div
//         className={`md:hidden fixed top-0 left-0 w-64 h-screen bg-white shadow-lg z-50 transform transition-transform duration-300 ${
//           menuOpen ? "translate-x-0" : "-translate-x-full"
//         }`}
//       >
//         {/* Drawer header - Changed text color to #6FEF34 */}
//         <div className="flex justify-between items-center px-4 py-4 border-b">
//           <h2 className="text-lg font-bold text-[#6FEF34]">Menu</h2>
//           <button onClick={() => setMenuOpen(false)}>
//             <X size={24} />
//           </button>
//         </div>

//         {/* Drawer links */}
//         <div className="px-4 py-2 flex flex-col gap-4 text-gray-700 font-medium">
//           {[
//             "Home",
//             "About",
//             "Services",
//             "Projects",
//             "Real Estate",
//             "Contact",
//           ].map((item) => {
//             if (item === "Services") {
//               return (
//                 <div key="Services">
//                   <button
//                     className="flex items-center justify-between w-full"
//                     onClick={() => setShowServices(!showServices)}
//                   >
//                     <span>Services</span>
//                     <ChevronDown
//                       size={16}
//                       className={`transition-transform ${
//                         showServices ? "rotate-180" : ""
//                       }`}
//                     />
//                   </button>

//                   {/* Services box */}
//                   {showServices && (
//                     <div className="mt-2 border border-gray-300 rounded-md p-3 bg-gray-50 shadow-inner">
//                       <div className="flex flex-col divide-y divide-gray-300">
//                         {servicesLinks.map((service) => (
//                           <Link
//                             key={service}
//                             to={`/services/${service
//                               .toLowerCase()
//                               .replace(/\s+/g, "-")}`}
//                             onClick={() => {
//                               setMenuOpen(false);
//                               setShowServices(false);
//                             }}
//                             // Changed hover text and underline color to #6FEF34
//                             className="py-2 pl-2 text-sm relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-[#6FEF34] hover:pl-3"
//                           >
//                             {service}
//                           </Link>
//                         ))}
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               );
//             }

//             /* All other top‑level links */
//             const path =
//               item === "Home"
//                 ? "/"
//                 : `/${item.toLowerCase().replace(/\s+/g, "-")}`;
//             return (
//               <Link
//                 key={item}
//                 to={path}
//                 onClick={() => setMenuOpen(false)}
//                 // Changed hover text and underline color to #6FEF34
//                 className="relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300 hover:text-[#6FEF34] hover:pl-2"
//               >
//                 {item}
//               </Link>
//             );
//           })}
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Phone,
  Facebook,
  Twitter,
  Instagram,
  Youtube,
  ChevronDown,
  Menu,
  X,
} from "lucide-react";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [trigger, setTrigger] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setTrigger(false);
      setTimeout(() => setTrigger(true), 150); // restart animation
    }, 5000); // every 5 seconds

    setTrigger(true); // trigger on initial mount

    return () => clearInterval(interval); // clean up
  }, []);
  // const [trigger, setTrigger] = useState(false);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     setTrigger(false);
  //     setTimeout(() => setTrigger(true), 50); // restart animation
  //   }, 5000); // every 5 seconds

  //   setTrigger(true); // initial animation

  //   return () => clearInterval(interval);
  // }, []);

  const servicesLinks = [
    "Building Renovation",
    "Civil Contract",
    "Architecture",
    "Interior Design",
    "Tiles Installation",
    "Plumbing",
  ];

  useEffect(() => {
    if (!menuOpen) setShowServices(false);
  }, [menuOpen]);

  return (
    <header className="bg-blue-700 sticky top-0 z-50">
      <div className="shadow-md">
        <div className="flex justify-between items-center px-4 md:px-16 py-4">
          <Link to="/">
            {/* <div
              className="flex flex-wrap text-white text-l sm:text-2xl md:text-2xl"
              style={{
                fontFamily: "'Cinzel Decorative', cursive",
                color: "#6FEF34",
              }}
            >
              {"Sanctus Property Pvt Ltd".split("").map((char, index) => (
                <span
                  key={index + (trigger ? "on" : "off")}
                  className="inline-block"
                  style={{
                    animation: trigger
                      ? `wave 0.6s ease-in-out forwards ${index * 0.1}s`
                      : "none",
                    opacity: 0,
                    display: "inline-block",
                  }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </div> */}
            <div
              className="flex flex-wrap text-white text-l sm:text-2xl md:text-2xl"
              style={{
                fontFamily: "'Cinzel Decorative', cursive",
                color: "white", // inner color
              }}
            >
              {"Sanctus Property Pvt Ltd".split("").map((char, index) => (
                <span
                  key={index + (trigger ? "on" : "off")}
                  className="inline-block"
                  style={{
                    animation: trigger
                      ? `wave 0.6s ease-in-out forwards ${index * 0.1}s`
                      : "none",
                    opacity: 0,
                    display: "inline-block",
                    textShadow: `
          -1px -1px 0 #000,
           1px -1px 0 #000,
          -1px  1px 0 #000,
           1px  1px 0 #000
        `,
                  }}
                >
                  {char === " " ? "\u00A0" : char}
                </span>
              ))}
            </div>
          </Link>

          {/* Desktop Navbar */}
          <nav className="hidden md:flex justify-center items-center gap-10 flex-1 text-white font-bold text-l">
            {[
              "Home",
              "About",
              "Company",
              "Services",
              "Projects",
              "Real Estate",
              "Contact",
            ].map((item) =>
              item === "Services" ? (
                <div key="Services" className="relative group cursor-pointer">
                  <div className="flex items-center gap-1 relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 group-hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300">
                    <span>Services</span>
                    <ChevronDown size={14} />
                  </div>
                  <div className="absolute top-full left-0 hidden group-hover:block bg-blue-700 text-white shadow-lg rounded-md py-2 w-56 z-50">
                    {servicesLinks.map((service) => (
                      <Link
                        key={service}
                        to={`/services/${service
                          .toLowerCase()
                          .replace(/\s+/g, "-")}`}
                        className="block px-4 py-2 text-sm relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300"
                      >
                        {service}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link
                  key={item}
                  to={
                    item === "Home"
                      ? "/"
                      : `/${item.toLowerCase().replace(/\s+/g, "-")}`
                  }
                  className="relative after:block after:h-[2px] after:bg-[#6FEF34] after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300"
                >
                  {item}
                </Link>
              )
            )}
          </nav>

          {/* Hamburger Button */}
          <button
            className="md:hidden transition-transform duration-300 hover:scale-110 text-white"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            {menuOpen ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`md:hidden fixed top-0 left-0 w-64 h-screen bg-blue-700 shadow-lg z-50 transform transition-transform duration-300 ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex justify-between items-center px-4 py-4 border-b border-[#6FEF34]">
          <h2 className="text-lg font-bold text-[#6FEF34]">
            Sanctus Property Pvt Ltd
          </h2>
          {/* <button onClick={() => setMenuOpen(false)} className="text-[#6FEF34]">
            <X size={24} />
          </button> */}
        </div>

        <div className="px-4 py-2 flex flex-col gap-4 text-white font-medium">
          {[
            "Home",
            "About",
            "Company",
            "Services",
            "Projects",
            "Real Estate",
            "Contact",
          ].map((item) => {
            if (item === "Services") {
              return (
                <div key="Services">
                  <button
                    className="flex items-center justify-between w-full  font-semibold"
                    onClick={() => setShowServices(!showServices)}
                  >
                    <span>Services</span>
                    <ChevronDown
                      size={16}
                      className={`transition-transform ${
                        showServices ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {showServices && (
                    <div className="mt-2 border border-[#6FEF34] rounded-md p-3 bg-blue-700 shadow-inner">
                      <div className="flex flex-col divide-y divide-[#6FEF34]/40">
                        {servicesLinks.map((service) => (
                          <Link
                            key={service}
                            to={`/services/${service
                              .toLowerCase()
                              .replace(/\s+/g, "-")}`}
                            onClick={() => {
                              setMenuOpen(false);
                              setShowServices(false);
                            }}
                            className="py-2 pl-2 text-sm relative after:block after:h-[2px] after:bg-white after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300"
                          >
                            {service}
                          </Link>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              );
            }

            const path =
              item === "Home"
                ? "/"
                : `/${item.toLowerCase().replace(/\s+/g, "-")}`;
            return (
              <Link
                key={item}
                to={path}
                onClick={() => setMenuOpen(false)}
                className="relative after:block after:h-[2px] after:bg-white after:scale-x-0 hover:after:scale-x-100 after:transition-transform after:origin-left transition-all duration-300"
              >
                {item}
              </Link>
            );
          })}
        </div>
      </div>
    </header>
  );
};

export default Header;
